import type {
  ReportFormData,
  SpeciesSearchField as SpeciesSearchFieldType,
} from '@/screens/ReportCreation/reportCreation.types';
import { useSpeciesSelectionStore } from '@/store/speciesSelection/speciesSelection.store';
import { useEffect } from 'react';
import { FieldValues, useController } from 'react-hook-form';
import { YStack } from 'tamagui';
import { FieldError } from '../FieldError';
import type { ControlledFieldController } from '../formController.types';
import { SpeciesSearchField } from './SpeciesSearchField';

interface ControlledSpeciesSearchFieldProps<FormValues extends FieldValues> {
  field: SpeciesSearchFieldType;
  formController: ControlledFieldController<FormValues>;
}

export const ControlledSpeciesSearchField = <
  FormValues extends FieldValues = ReportFormData,
>({
  field,
  formController,
}: ControlledSpeciesSearchFieldProps<FormValues>): React.ReactElement => {
  const { selection, clearSelection } = useSpeciesSelectionStore();
  const { field: controllerField, fieldState } = useController<FormValues>({
    ...formController,
  });

  useEffect(() => {
    if (!selection) {
      return;
    }

    controllerField.onChange(selection.value);
    clearSelection();
  }, [clearSelection, controllerField, selection]);

  const value =
    typeof controllerField.value === 'string' ? controllerField.value : '';

  return (
    <YStack gap="$1">
      <SpeciesSearchField field={field} value={value} displayValue={value} />
      <FieldError message={fieldState.error?.message} />
    </YStack>
  );
};
